import React from 'react';
export const DEFAULT_SIZE = {
  rectangle: { w: 140, h: 90 },
  ellipse: { w: 140, h: 90 },
  circle: { w: 100, h: 100 },
  rounded: { w: 140, h: 90 },
  diamond: { w: 130, h: 110 },
  triangle: { w: 130, h: 100 },
  hexagon: { w: 140, h: 120 },
  octagon: { w: 140, h: 120 },
  pentagon: { w: 140, h: 120 },
  cloud: { w: 170, h: 100 },
  cylinder: { w: 140, h: 110 },
  backwardParallelogram: { w: 140, h: 90 },
  lineElement: { w: 140, h: 4 },
  arrowline: { w: 140, h: 4 },
  arrowlineLeft: { w: 140, h: 4 },
  arrowlineUp: { w: 4, h: 140 },
  arrowlineDown: { w: 4, h: 140 },
  frame: { w: 260, h: 180 },
  text: { w: 140, h: 36 },
  table: { w: 220, h: 90 },
};

const CANVAS_LINE_TYPES = new Set(["lineElement", "arrowline", "arrowlineLeft", "arrowlineUp", "arrowlineDown"]);

export function isCanvasLine(el) {
  return CANVAS_LINE_TYPES.has(el.type);
}

export function getShapeToolFromPickerId(shapeId) {
  switch (shapeId) {
    case "rect":
      return "rectangle";
    case "ellipse":
      return "ellipse";
    case "diamond":
      return "diamond";
    case "triangle":
      return "triangle";
    case "hexagon":
      return "hexagon";
    case "octagon":
      return "octagon";
    case "pentagon":
      return "pentagon";
    case "cloud":
      return "cloud";
    case "cylinder":
      return "cylinder";
    case "arrowfat_left":
      return "arrowLeft";
    case "arrowfat_right":
      return "arrowRight";
    case "line":
      return "lineElement";
    case "arrow":
      return "arrowline";
    case "star":
      return "star";
    case "plus":
      return "plus";
    case "chat":
      return "speechBubble";
    case "cards_stack":
      return "multiDocument";
    case "circle_x":
    case "crosshair":
      return "summingJunction";
    case "cloud_bubble":
      return "cloud";
    case "cylinder_alt":
      return "cylinder";
    case "folder_open":
      return "folder";
    case "page":
    case "page_fold_large":
      return "document";
    case "parallelogram":
      return "parallelogram";
    case "parallelogram_alt":
      return "backwardParallelogram";
    case "pentagon_down":
      return "invertedTriangle";
    case "ribbed":
      return "predefinedProcess";
    case "trapezoid":
      return "trapezoid";
    case "table":
      return "rectangle";
    case "arrow_right":
      return "arrowline";
    case "arrow_left":
      return "arrowlineLeft";
    case "arrow_up":
      return "arrowlineUp";
    case "arrow_down":
      return "arrowlineDown";
    default:
      return "rectangle";
  }
}


// ---------- geometry helpers ----------
const POLYGON_POINTS = {
  diamond: [{ x: 50, y: 2 }, { x: 98, y: 50 }, { x: 50, y: 98 }, { x: 2, y: 50 }],
  triangle: [{ x: 50, y: 2 }, { x: 98, y: 98 }, { x: 2, y: 98 }],
  invertedTriangle: [{ x: 0, y: 0 }, { x: 100, y: 0 }, { x: 50, y: 100 }],
  pentagon: [{ x: 50, y: 0 }, { x: 100, y: 35 }, { x: 82, y: 100 }, { x: 18, y: 100 }, { x: 0, y: 35 }],
  hexagon: [{ x: 25, y: 0 }, { x: 75, y: 0 }, { x: 100, y: 50 }, { x: 75, y: 100 }, { x: 25, y: 100 }, { x: 0, y: 50 }],
  octagon: [{ x: 30, y: 0 }, { x: 70, y: 0 }, { x: 100, y: 30 }, { x: 100, y: 70 }, { x: 70, y: 100 }, { x: 30, y: 100 }, { x: 0, y: 70 }, { x: 0, y: 30 }],
  parallelogram: [{ x: 20, y: 0 }, { x: 100, y: 0 }, { x: 80, y: 100 }, { x: 0, y: 100 }],
  backwardParallelogram: [{ x: 0, y: 0 }, { x: 80, y: 0 }, { x: 100, y: 100 }, { x: 20, y: 100 }],
  trapezoid: [{ x: 20, y: 0 }, { x: 80, y: 0 }, { x: 100, y: 100 }, { x: 0, y: 100 }],
  invertedTrapezoid: [{ x: 0, y: 0 }, { x: 100, y: 0 }, { x: 80, y: 100 }, { x: 20, y: 100 }],
  manualInput: [{ x: 0, y: 20 }, { x: 100, y: 0 }, { x: 100, y: 100 }, { x: 0, y: 100 }],
  manualOperation: [{ x: 0, y: 0 }, { x: 100, y: 0 }, { x: 80, y: 100 }, { x: 20, y: 100 }],
  preparation: [{ x: 15, y: 0 }, { x: 85, y: 0 }, { x: 100, y: 50 }, { x: 85, y: 100 }, { x: 15, y: 100 }, { x: 0, y: 50 }],
  star: [{ x: 50, y: 2 }, { x: 61, y: 37 }, { x: 98, y: 37 }, { x: 68, y: 59 }, { x: 79, y: 95 }, { x: 50, y: 73 }, { x: 21, y: 95 }, { x: 32, y: 59 }, { x: 2, y: 37 }, { x: 39, y: 37 }],
  arrowRight: [{ x: 0, y: 15 }, { x: 60, y: 15 }, { x: 60, y: 0 }, { x: 100, y: 30 }, { x: 60, y: 60 }, { x: 60, y: 45 }, { x: 0, y: 45 }],
  arrowLeft: [{ x: 100, y: 15 }, { x: 40, y: 15 }, { x: 40, y: 0 }, { x: 0, y: 30 }, { x: 40, y: 60 }, { x: 40, y: 45 }, { x: 100, y: 45 }],
  cross: [{ x: 35, y: 0 }, { x: 65, y: 0 }, { x: 65, y: 35 }, { x: 100, y: 35 }, { x: 100, y: 65 }, { x: 65, y: 65 }, { x: 65, y: 100 }, { x: 35, y: 100 }, { x: 35, y: 65 }, { x: 0, y: 65 }, { x: 0, y: 35 }, { x: 35, y: 35 }],
  plus: [{ x: 35, y: 0 }, { x: 65, y: 0 }, { x: 65, y: 35 }, { x: 100, y: 35 }, { x: 100, y: 65 }, { x: 65, y: 65 }, { x: 65, y: 100 }, { x: 35, y: 100 }, { x: 35, y: 65 }, { x: 0, y: 65 }, { x: 0, y: 35 }, { x: 35, y: 35 }],
};

export function pointInBox(el, nx, ny) {
  return { x: el.x + el.w * nx, y: el.y + el.h * ny };
}

function pointInMeetViewBox(el, viewW, viewH, vx, vy) {
  const scale = Math.min(el.w / viewW, el.h / viewH);
  const renderedW = viewW * scale;
  const renderedH = viewH * scale;
  return {
    x: el.x + (el.w - renderedW) / 2 + vx * scale,
    y: el.y + (el.h - renderedH) / 2 + vy * scale,
  };
}

function polygonAnchor(el, side, points) {
  const centerX = 50;
  const centerY = 50;
  const intersections = [];
  const verticalIntersections = [];

  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];

    if ((a.y <= centerY && b.y >= centerY) || (b.y <= centerY && a.y >= centerY)) {
      if (a.y !== b.y) {
        const t = (centerY - a.y) / (b.y - a.y);
        intersections.push(a.x + (b.x - a.x) * t);
      } else if (a.y === centerY) {
        intersections.push(a.x, b.x);
      }
    }

    if ((a.x <= centerX && b.x >= centerX) || (b.x <= centerX && a.x >= centerX)) {
      if (a.x !== b.x) {
        const t = (centerX - a.x) / (b.x - a.x);
        verticalIntersections.push(a.y + (b.y - a.y) * t);
      } else if (a.x === centerX) {
        verticalIntersections.push(a.y, b.y);
      }
    }
  }

  switch (side) {
    case "left":
      return pointInBox(el, Math.min(...intersections) / 100, centerY / 100);
    case "right":
      return pointInBox(el, Math.max(...intersections) / 100, centerY / 100);
    case "top":
      return pointInBox(el, centerX / 100, Math.min(...verticalIntersections) / 100);
    case "bottom":
      return pointInBox(el, centerX / 100, Math.max(...verticalIntersections) / 100);
    default:
      return pointInBox(el, 0.5, 0.5);
  }
}

function polygonRayPoint(el, handle, points, viewW = 100, viewH = 100, useMeetBox = false) {
  const sx = handle.includes("w") ? -1 : 1;
  const sy = handle.includes("n") ? -1 : 1;
  const cx = viewW / 2;
  const cy = viewH / 2;
  const dx = sx * viewW;
  const dy = sy * viewH;
  let bestT = Infinity;

  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    const ex = b.x - a.x;
    const ey = b.y - a.y;
    const denom = dx * ey - dy * ex;
    if (Math.abs(denom) < 0.0001) continue;

    const ax = a.x - cx;
    const ay = a.y - cy;
    const t = (ax * ey - ay * ex) / denom;
    const u = (ax * dy - ay * dx) / denom;
    if (t >= 0 && u >= 0 && u <= 1 && t < bestT) bestT = t;
  }

  if (!Number.isFinite(bestT)) {
    return pointInBox(el, handle.includes("w") ? 0 : 1, handle.includes("n") ? 0 : 1);
  }

  const vx = cx + dx * bestT;
  const vy = cy + dy * bestT;
  return useMeetBox ? pointInMeetViewBox(el, viewW, viewH, vx, vy) : pointInBox(el, vx / viewW, vy / viewH);
}

export function resizeHandlePoint(el, handle) {
  if (POLYGON_POINTS[el.type]) {
    const useMeetBox = ["arrowLeft", "arrowRight", "cross", "plus"].includes(el.type);
    const viewH = el.type === "arrowLeft" || el.type === "arrowRight" ? 60 : 100;
    return polygonRayPoint(el, handle, POLYGON_POINTS[el.type], 100, viewH, useMeetBox);
  }

  if (el.type === "ellipse" || el.type === "circle") {
    const offset = Math.SQRT1_2 / 2;
    return pointInBox(el, 0.5 + (handle.includes("w") ? -offset : offset), 0.5 + (handle.includes("n") ? -offset : offset));
  }

  if (el.type === "or" || el.type === "summingJunction") {
    const offset = 46 * Math.SQRT1_2;
    return pointInMeetViewBox(el, 100, 100, 50 + (handle.includes("w") ? -offset : offset), 50 + (handle.includes("n") ? -offset : offset));
  }

  if (el.type === "cylinder") {
    const x = handle.includes("w") ? 30 : 70;
    const y = handle.includes("n") ? 16 : 84;
    return pointInMeetViewBox(el, 100, 100, x, y);
  }

  if (el.type === "cloud") {
    const points = [{ x: 23.9, y: 24.2 }, { x: 58.3, y: 29.6 }, { x: 66.4, y: 38.8 }, { x: 26, y: 44 }];
    return polygonRayPoint(el, handle, points, 100, 60, true);
  }

  if (el.type === "speechBubble" || el.type === "comment") {
    const x = handle.includes("w") ? 4 : 96;
    const y = handle.includes("n") ? 8 : 56;
    return pointInMeetViewBox(el, 100, 80, x, y);
  }

  if (el.type === "document") {
    return pointInBox(el, handle.includes("w") ? 0.02 : 0.98, handle.includes("n") ? 0.025 : 0.83);
  }

  if (el.type === "multiDocument") {
    return pointInBox(el, handle.includes("w") ? 0.12 : 0.92, handle.includes("n") ? 0.09 : 0.78);
  }

  if (el.type === "storedData" || el.type === "folder" || el.type === "display") {
    return pointInBox(el, handle.includes("w") ? 0.02 : 0.98, handle.includes("n") ? 0.03 : 0.97);
  }

  return pointInBox(el, handle.includes("w") ? 0 : 1, handle.includes("n") ? 0 : 1);
}

function unrotatedAnchor(el, side) {
  if (POLYGON_POINTS[el.type] && el.type !== "arrowLeft" && el.type !== "arrowRight") {
    return polygonAnchor(el, side, POLYGON_POINTS[el.type]);
  }

  if (el.type === "ellipse" || el.type === "circle") {
    switch (side) {
      case "left": return pointInBox(el, 0, 0.5);
      case "right": return pointInBox(el, 1, 0.5);
      case "top": return pointInBox(el, 0.5, 0);
      case "bottom": return pointInBox(el, 0.5, 1);
      default: break;
    }
  }

  if (el.type === "or" || el.type === "summingJunction") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 100, 4, 50);
      case "right": return pointInMeetViewBox(el, 100, 100, 96, 50);
      case "top": return pointInMeetViewBox(el, 100, 100, 50, 4);
      case "bottom": return pointInMeetViewBox(el, 100, 100, 50, 96);
      default: break;
    }
  }

  if (el.type === "cylinder") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 100, 22, 50);
      case "right": return pointInMeetViewBox(el, 100, 100, 78, 50);
      case "top": return pointInMeetViewBox(el, 100, 100, 50, 12);
      case "bottom": return pointInMeetViewBox(el, 100, 100, 50, 88);
      default: break;
    }
  }

  if (el.type === "cloud") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 60, 16, 34);
      case "right": return pointInMeetViewBox(el, 100, 60, 66.4, 38.8);
      case "top": return pointInMeetViewBox(el, 100, 60, 35, 15.7);
      case "bottom": return pointInMeetViewBox(el, 100, 60, 42, 48.4);
      default: break;
    }
  }

  if (el.type === "speechBubble" || el.type === "comment") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 80, 4, 32);
      case "right": return pointInMeetViewBox(el, 100, 80, 96, 32);
      case "top": return pointInMeetViewBox(el, 100, 80, 50, 8);
      case "bottom": return pointInMeetViewBox(el, 100, 80, 50, 56);
      default: break;
    }
  }

  if (el.type === "document") {
    switch (side) {
      case "left": return pointInBox(el, 0.02, 0.4);
      case "right": return pointInBox(el, 0.98, 0.4);
      case "top": return pointInBox(el, 0.5, 0.025);
      case "bottom": return pointInBox(el, 0.5, 0.83);
      default: break;
    }
  }

  if (el.type === "multiDocument") {
    switch (side) {
      case "left": return pointInBox(el, 0.12, 0.4);
      case "right": return pointInBox(el, 0.92, 0.4);
      case "top": return pointInBox(el, 0.52, 0.09);
      case "bottom": return pointInBox(el, 0.52, 0.78);
      default: break;
    }
  }

  if (el.type === "storedData" || el.type === "folder") {
    switch (side) {
      case "left": return pointInBox(el, 0.02, 0.5);
      case "right": return pointInBox(el, 0.98, 0.5);
      case "top": return pointInBox(el, 0.5, 0.03);
      case "bottom": return pointInBox(el, 0.5, 0.97);
      default: break;
    }
  }

  if (el.type === "display") {
    switch (side) {
      case "left": return pointInBox(el, 0.02, 0.5);
      case "right": return pointInBox(el, 0.96, 0.5);
      case "top": return pointInBox(el, 0.5, 0.03);
      case "bottom": return pointInBox(el, 0.5, 0.97);
      default: break;
    }
  }

  if (el.type === "arrowRight") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 60, 0, 30);
      case "right": return pointInMeetViewBox(el, 100, 60, 100, 30);
      case "top": return pointInMeetViewBox(el, 100, 60, 60, 0);
      case "bottom": return pointInMeetViewBox(el, 100, 60, 60, 60);
      default: break;
    }
  }

  if (el.type === "arrowLeft") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 60, 0, 30);
      case "right": return pointInMeetViewBox(el, 100, 60, 100, 30);
      case "top": return pointInMeetViewBox(el, 100, 60, 40, 0);
      case "bottom": return pointInMeetViewBox(el, 100, 60, 40, 60);
      default: break;
    }
  }

  if (el.type === "cross" || el.type === "plus") {
    switch (side) {
      case "left": return pointInMeetViewBox(el, 100, 100, 0, 50);
      case "right": return pointInMeetViewBox(el, 100, 100, 100, 50);
      case "top": return pointInMeetViewBox(el, 100, 100, 50, 0);
      case "bottom": return pointInMeetViewBox(el, 100, 100, 50, 100);
      default: break;
    }
  }

  switch (side) {
    case "left": return { x: el.x, y: el.y + el.h / 2 };
    case "right": return { x: el.x + el.w, y: el.y + el.h / 2 };
    case "top": return { x: el.x + el.w / 2, y: el.y };
    case "bottom": return { x: el.x + el.w / 2, y: el.y + el.h };
    default: return { x: el.x + el.w / 2, y: el.y + el.h / 2 };
  }
}

export function autoAnchors(elA, elB) {
  const cA = { x: elA.x + elA.w / 2, y: elA.y + elA.h / 2 };
  const cB = { x: elB.x + elB.w / 2, y: elB.y + elB.h / 2 };
  const dx = cB.x - cA.x;
  const dy = cB.y - cA.y;
  let sideA, sideB;
  if (Math.abs(dx) > Math.abs(dy)) {
    sideA = dx >= 0 ? "right" : "left";
    sideB = dx >= 0 ? "left" : "right";
  } else {
    sideA = dy >= 0 ? "bottom" : "top";
    sideB = dy >= 0 ? "top" : "bottom";
  }
  return { p1: anchorPoint(elA, sideA), p2: anchorPoint(elB, sideB), sideA, sideB };
}

export function orthPath(p1, side1, p2) {
  if (Math.abs(p1.x - p2.x) < 0.01 || Math.abs(p1.y - p2.y) < 0.01) return `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y}`;
  const horizontal = side1 === "left" || side1 === "right";
  try {
    if (horizontal) {
      const midX = (p1.x + p2.x) / 2;
      return `M ${p1.x} ${p1.y} L ${midX} ${p1.y} L ${midX} ${p2.y} L ${p2.x} ${p2.y}`;
    }
    const midY = (p1.y + p2.y) / 2;
    return `M ${p1.x} ${p1.y} L ${p1.x} ${midY} L ${p2.x} ${midY} L ${p2.x} ${p2.y}`;
  } catch {
    return `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y}`;
  }
}

export function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }

// ---------- shape visual ----------
export const ShapeBody = React.memo(function ShapeBody({ el }) {

  const fillProps = { fill: el.fill || "transparent", stroke: el.stroke, strokeWidth: el.strokeWidth ?? 1, strokeDasharray: el.dash === "dashed" ? "6 4" : el.dash === "dotted" ? "2 3" : undefined, vectorEffect: "non-scaling-stroke" };
  const strokeProps = { stroke: el.stroke, strokeWidth: el.strokeWidth ?? 1, vectorEffect: "non-scaling-stroke" };
  const polygon = (points) => (
    <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
      <polygon points={points} {...fillProps} strokeLinejoin="round" />
    </svg>
  );

  // ---- Basic shapes ----
  if (el.type === "square" || el.type === "rectangle" || el.type === "rounded") {
    return <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><rect x="1" y="1" width="98" height="98" rx={el.radius ?? (el.type === "rounded" ? 12 : 0)} {...fillProps} /></svg>;
  }
  if (el.type === "ellipse" || el.type === "circle") {
    return <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><ellipse cx="50" cy="50" rx="49" ry="49" {...fillProps} /></svg>;
  }
  if (el.type === "diamond") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
        <polygon points="50,2 98,50 50,98 2,50" {...fillProps} strokeLinejoin="round" />
      </svg>
    );
  }
  if (el.type === "triangle") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
        <polygon points="50,2 98,98 2,98" {...fillProps} strokeLinejoin="round" />
      </svg>
    );
  }
  if (el.type === "invertedTriangle") {
    return polygon("2,2 98,2 50,98");
  }
  if (el.type === "pentagon") {
    return polygon("50,2 98,35 82,98 18,98 2,35");
  }
  if (el.type === "hexagon") {
    return polygon("25,2 75,2 98,50 75,98 25,98 2,50");
  }
  if (el.type === "octagon") {
    return polygon("30,2 70,2 98,30 98,70 70,98 30,98 2,70 2,30");
  }
  if (el.type === "cross" || el.type === "plus") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M35 0h30v35h35v30H65v35H35V65H0V35h35V0z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "arrowLeft") {
    return (
      <svg viewBox="0 0 100 60" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M40 0h60v20H40v10L0 15 40 0v10z M40 40h60v20H40v10L0 45 40 30v10z M0 15L40 0v30z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "arrowRight") {
    return (
      <svg viewBox="0 0 100 60" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M0 15h60V0l40 30-40 30V45H0V15z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "chevron") {
    return (
      <svg viewBox="0 0 100 60" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M0 0h55l25 30-25 30H0l25-30L0 0z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "star") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <polygon points="50,2 61,37 98,37 68,59 79,95 50,73 21,95 32,59 2,37 39,37" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "speechBubble" || el.type === "comment") {
    return (
      <svg viewBox="0 0 100 80" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M8 8h84a4 4 0 0 1 4 4v40a4 4 0 0 1-4 4H40l-18 16V56H8a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4z" {...fillProps} />
      </svg>
    );
  }

  // ---- Arrows / lines (top toolbar) ----
  if (el.type === "line") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
        <line x1="5" y1="95" x2="95" y2="5" {...strokeProps} strokeLinecap="round" />
      </svg>
    );
  }
  if (el.type === "straightArrow") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
        <defs>
          <marker id={`arrowhead-${el.id}`} markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <path d="M0,0 L8,4 L0,8 Z" fill={el.stroke} />
          </marker>
        </defs>
        <line x1="5" y1="95" x2="88" y2="12" {...strokeProps} strokeLinecap="round" markerEnd={`url(#arrowhead-${el.id})`} />
      </svg>
    );
  }
  if (el.type === "curvedArrow") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
        <defs>
          <marker id={`curvehead-${el.id}`} markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <path d="M0,0 L8,4 L0,8 Z" fill={el.stroke} />
          </marker>
        </defs>
        <path d="M15 90 C 15 40, 60 60, 60 20" fill="none" {...strokeProps} strokeLinecap="round" markerEnd={`url(#curvehead-${el.id})`} />
      </svg>
    );
  }
  if (el.type === "sCurveArrow") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none">
        <defs>
          <marker id={`scurvehead-${el.id}`} markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <path d="M0,0 L8,4 L0,8 Z" fill={el.stroke} />
          </marker>
        </defs>
        <path d="M20 90 C 60 90, 10 40, 55 15" fill="none" {...strokeProps} strokeLinecap="round" markerEnd={`url(#scurvehead-${el.id})`} />
      </svg>
    );
  }

  // ---- Flowchart shapes ----
  if (el.type === "process") {
    return <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><rect x="1" y="1" width="98" height="98" rx={el.radius ?? (el.type === "rounded" ? 12 : 0)} {...fillProps} /></svg>;
  }
  if (el.type === "predefinedProcess") {
    return (
      <svg viewBox="0 0 100 60" width="100%" height="100%" preserveAspectRatio="none">
        <rect x="1" y="1" width="98" height="58" {...fillProps} />
        <line x1="12" y1="1" x2="12" y2="59" {...strokeProps} />
        <line x1="88" y1="1" x2="88" y2="59" {...strokeProps} />
      </svg>
    );
  }
  if (el.type === "cylinder") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M22 24c0-7 10-12 28-12s28 5 28 12v52c0 7-10 12-28 12s-28-5-28-12V24z" {...fillProps} />
        <ellipse cx="50" cy="24" rx="28" ry="12" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "parallelogram") {
    return polygon("20,2 98,2 80,98 2,98");
  }
  if (el.type === "backwardParallelogram") {
    return polygon("2,2 80,2 98,98 20,98");
  }
  if (el.type === "trapezoid") {
    return polygon("20,2 80,2 98,98 2,98");
  }
  if (el.type === "invertedTrapezoid") {
    return polygon("2,2 98,2 80,98 20,98");
  }
  if (el.type === "document") {
    return (
      <svg viewBox="0 0 100 80" width="100%" height="100%" preserveAspectRatio="none">
        <path d="M2 2h96v60c-16 0-16 14-32 14s-16-14-32-14-16 14-32 14V2z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "multiDocument") {
    return (
      <svg viewBox="0 0 100 90" width="100%" height="100%" preserveAspectRatio="none">
        <path d="M12 8h80v50c-13 0-13 12-26 12s-13-12-26-12-13 12-26 12V8z" {...fillProps} transform="translate(-8,-6)" />
        <path d="M12 8h80v50c-13 0-13 12-26 12s-13-12-26-12-13 12-26 12V8z" {...fillProps} transform="translate(-4,-3)" />
        <path d="M12 8h80v50c-13 0-13 12-26 12s-13-12-26-12-13 12-26 12V8z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "storedData" || el.type === "folder") {
    return (
      <svg viewBox="0 0 100 70" width="100%" height="100%" preserveAspectRatio="none">
        <path d="M2 2h70a26 33 0 0 1 26 33 26 33 0 0 1-26 33H2z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "display") {
    return (
      <svg viewBox="0 0 100 60" width="100%" height="100%" preserveAspectRatio="none">
        <path d="M2 30C2 14 14 2 30 2h50a34 28 0 0 1 16 28 34 28 0 0 1-16 28H30C14 58 2 46 2 30z" {...fillProps} />
      </svg>
    );
  }
  if (el.type === "manualInput") {
    return polygon("2,20 98,2 98,98 2,98");
  }
  if (el.type === "manualOperation") {
    return polygon("2,2 98,2 80,98 20,98");
  }
  if (el.type === "preparation") {
    return polygon("15,2 85,2 98,50 85,98 15,98 2,50");
  }
  if (el.type === "or") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <circle cx="50" cy="50" r="46" {...fillProps} />
        <line x1="50" y1="4" x2="50" y2="96" {...strokeProps} />
        <line x1="4" y1="50" x2="96" y2="50" {...strokeProps} />
      </svg>
    );
  }
  if (el.type === "summingJunction") {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <circle cx="50" cy="50" r="46" {...fillProps} />
        <line x1="18" y1="18" x2="82" y2="82" {...strokeProps} />
        <line x1="82" y1="18" x2="18" y2="82" {...strokeProps} />
      </svg>
    );
  }
  if (el.type === "cloud") {
    return (
      <svg viewBox="0 0 100 60" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M26 44c-5.5 0-10-4.5-10-10 0-4.8 3.4-8.8 7.9-9.8 1.4-4.9 5.8-8.5 11.1-8.5 4 0 7.6 1.8 9.8 4.7 1.5-1.2 3.3-1.9 5.2-1.9 4.8 0 8.7 3.9 8.7 8.7 0 .8-.1 1.6-.4 2.4 4.6.7 8.1 4.7 8.1 9.4 0 5.2-4.2 9.4-9.4 9.4H26z"
          {...fillProps} />
      </svg>
    );
  }

  // fallback: plain rounded rectangle
  return <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><rect x="1" y="1" width="98" height="98" rx={el.radius ?? 8} {...fillProps} /></svg>;
});


export function anchorPoint(el, side) {
  const p = unrotatedAnchor(el, side);
  const angle = (el.rotation || 0) * Math.PI / 180, cx = el.x + el.w / 2, cy = el.y + el.h / 2;
  return { x: cx + (p.x - cx) * Math.cos(angle) - (p.y - cy) * Math.sin(angle), y: cy + (p.x - cx) * Math.sin(angle) + (p.y - cy) * Math.cos(angle) };
}
export function connectorGeometry(c, a, b) {
  const auto = autoAnchors(a, b);
  const p1 = c.fromSide ? anchorPoint(a, c.fromSide) : auto.p1;
  const p2 = c.toSide ? anchorPoint(b, c.toSide) : auto.p2;
  const side = c.fromSide || auto.sideA;
  const d = c.kind === 'straight' ? `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y}` : c.kind === 'curved'
    ? `M ${p1.x} ${p1.y} C ${(p1.x + p2.x) / 2} ${p1.y}, ${(p1.x + p2.x) / 2} ${p2.y}, ${p2.x} ${p2.y}`
    : orthPath(p1, side, p2);
  return { p1, p2, d };
}
